import { FC, memo, PropsWithChildren } from 'react';

import { useSubscribeToUserUpdated } from '../../../websocketApi';
import { useUserData } from '../hooks/useUserData';

const UserSubscriptionsComponent: FC<PropsWithChildren> = ({ children }) => {
  const { user, refetch } = useUserData();
  useSubscribeToUserUpdated(user?.id ?? '', () => refetch());

  return <>{children}</>;
};

export const UserSubscriptions = memo(UserSubscriptionsComponent);
